/**
 * A class representing a client context in a client-side environment.
 */
export class RequestContextClient {
  /**
   * The internal `Store` for context data.
   * using global object `EDM.Venom.requestContextClient` for transfered data from server.
   * @private
   * @type {RequestContextClientStore}
   */
  #store;

  constructor() {
    // Perform a nullish check on the required context during import.
    // This is necessary when importing out of scope (e.g., in e2e tests),
    // where AsyncLocalStorage may not be defined yet.
    this.#store = global.EDM?.Venom?.requestContextClient ?? {};
  }

  /**
   * Returns context store.
   * @returns {RequestContextClientStore}
   */
  getStore() {
    return this.#store;
  }

  /**
   * This method is intended for asynchronous context management in Node.js.
   * It throws an error in the client-side context as it's not implemented here.
   * @throws {Error} "Method not implemented."
   */
  // eslint-disable-next-line class-methods-use-this
  run() {
    throw new Error('Method not implemented.');
  }
}
